<template lang='pug' src='./Home.pug'></template>

<script>
  import Navbar from '../../components/Navbar/Navbar'
  import Wrapper from '../../components/Wrapper/Wrapper'
  import BookHolidayPopup from
    '../../components/BookHolidayPopup/BookHolidayPopup'
  import OnHolidaysPopup from '../../components/OnHolidaysPopup/OnHolidaysPopup'

  export default {
    name: 'Home',
    components: {
      Navbar,
      Wrapper,
      BookHolidayPopup,
      OnHolidaysPopup
    }
  }
</script>

<style lang='css' src='./Home.css' scoped></style>



// WEBPACK FOOTER //
// Home.vue?c3f8c482